import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./OptionsMenu.module.css";
import progressTracker from "../../../common/assets/TeacherDashboard/progressTracker.png";
import progressTrackerSelected from "../../../common/assets/TeacherDashboard/progressTrackerSelected.png";
import studentProfiles from "../../../common/assets/TeacherDashboard/studentProfiles.png";
import studentProfilesSelected from "../../../common/assets/TeacherDashboard/studentProfilesSelected.png";
import helpRequests from "../../../common/assets/TeacherDashboard/helpRequests.png";
import helpRequestsSelected from "../../../common/assets/TeacherDashboard/helpRequestsSelected.png";
import projectSubmission from "../../../common/assets/TeacherDashboard/projectSubmissions.png";
import projectLibrary from "../../../common/assets/TeacherDashboard/projectLibrary.png";
import logout from "../../../common/assets/logout.png";
import profile from "../../../common/assets/profile.png";
import settings from "../../../common/assets/settings.png";
import arrowLeft from "../../../common/assets/arrowLeft.png";

export default function OptionsMenu({ profile_pic, teacher_id }) {
  const location = useLocation();

  const isActiveRoute = (routePath) => {
    return location.pathname === routePath;
  };

  const handleLogout = () => {
    localStorage.clear();
  };

  return (
    // Main division for all items inside Options Menu aka side nav bar
    <div>
      <div id={styles.teacherDiv}>
        <img className={styles.teacherImage} src={profile_pic} alt=""></img>
      </div>

      <div id={styles.topOptions}>
        <ul>
          <li className={`${styles.topOption} ${isActiveRoute("/progress-tracker") ? styles.activeOption : ""}`}>
            <img src={isActiveRoute("/progress-tracker") ? progressTrackerSelected : progressTracker} className={styles.topLogos} alt="tracker"></img>
            <span>
              <Link to="/progress-tracker">PROGRESS TRACKER</Link>
            </span>
          </li>

          <li className={`${styles.topOption} ${isActiveRoute("/student-profiles") ? styles.activeOption : ""}`}>
            <img src={isActiveRoute("/student-profiles") ? studentProfilesSelected : studentProfiles} className={styles.topLogos} alt="profiles"></img>
            <span>
              <Link to="/student-profiles"> STUDENT PROFILES</Link>
            </span>
          </li>

          <li className={`${styles.topOption} ${isActiveRoute("/help-requests") ? styles.activeOption : ""}`}>
            <img src={isActiveRoute("/help-requests") ? helpRequestsSelected : helpRequests} className={styles.topLogos} alt="requests"></img>
            <span>
              <Link to="/help-requests">HELP REQUESTS</Link>
            </span>
          </li>

          <li className={styles.topOption}>
            <img src={projectSubmission} className={styles.topLogos} alt="Project Submissions"></img>
            <span>PROJECT SUBMISSIONS</span>
          </li>

          <li className={styles.topOption}>
            <img src={projectLibrary} className={styles.topLogos} alt="Project Submissions"></img>
            <span>PROJECT LIBRARY</span>
          </li>
        </ul>
      </div>

      <div>
        <img src={arrowLeft} className={styles.arrowLeft} />
      </div>

      <ol id={styles.bottomOptions}>
        <li className={styles.bottomOption}>
          <img src={profile} className={styles.bottomLogos} alt="profile"></img>
          <Link to={`/teacher-profile-viewer/${teacher_id}`}>My Profile</Link>
        </li>
        <li className={styles.bottomOption}>
          <img src={settings} className={styles.bottomLogos} alt="settings"></img>
          <p>Settings</p>
        </li>
        <li className={styles.bottomOption}>
          <img src={logout} className={styles.bottomLogos} alt="log out"></img>
          <div>
            <Link
              to="/"
              onClick={() => {
                handleLogout();
              }}
            >
              Log out
            </Link>
          </div>
        </li>
      </ol>
    </div>
  );
}
